// @df/ui - Cookie consent storage utility
// Manages consent state in localStorage with a shared key across all apps
const CONSENT_KEY = 'df_cookie_consent';
/**
 * Get the current consent status from localStorage
 * @returns 'accepted', 'rejected', or null if no decision has been made
 */
export function getConsent() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return null;
    }
    try {
        const value = localStorage.getItem(CONSENT_KEY);
        if (value === 'accepted' || value === 'rejected') {
            return value;
        }
        return null;
    }
    catch (error) {
        console.warn('[ConsentStorage] Failed to read consent from localStorage:', error);
        return null;
    }
}
/**
 * Set the consent status in localStorage
 * @param status - 'accepted' or 'rejected'
 */
export function setConsent(status) {
    if (typeof window === 'undefined' || !window.localStorage) {
        console.warn('[ConsentStorage] localStorage not available');
        return;
    }
    try {
        localStorage.setItem(CONSENT_KEY, status);
    }
    catch (error) {
        console.warn('[ConsentStorage] Failed to write consent to localStorage:', error);
    }
}
/**
 * Check if a consent decision exists (regardless of acceptance/rejection)
 * @returns true if user has made a decision, false otherwise
 */
export function hasConsent() {
    return getConsent() !== null;
}
/**
 * Clear the consent status from localStorage (for testing/reset purposes)
 */
export function clearConsent() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }
    try {
        localStorage.removeItem(CONSENT_KEY);
    }
    catch (error) {
        console.warn('[ConsentStorage] Failed to clear consent from localStorage:', error);
    }
}
